import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EntiteIdResponse, EntiteResponse} from '../../models/entite/EntiteResponse';
import {environment} from '../../../environments/environment.local';
import {EntiteBody} from '../../models/entite/EntiteBody';

@Injectable({
  providedIn: 'root'
})
export class EntiteService {

  private apiUrl = `${environment.apiUrl}/entities`;

  constructor(private http: HttpClient) {
  }

  getEntities(params?: any): Observable<EntiteResponse> {
    return this.http.get<EntiteResponse>(this.apiUrl, {params});
  }

  getEntitiesById(id: any): Observable<EntiteIdResponse> {
    return this.http.get<EntiteIdResponse>(this.apiUrl + '/' + id);
  }

  postEntity(entityBody: EntiteBody): Observable<EntiteResponse> {
    return this.http.post<EntiteResponse>(this.apiUrl, entityBody);
  }

  updateEntity(id: number, entityBody: EntiteBody): Observable<EntiteResponse> {
    return this.http.put<EntiteResponse>(`${this.apiUrl}/${id}`, entityBody);
  }
}
